import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';
import { useState } from 'react';
import TabContext from '@mui/lab/TabContext';
import Box from '@mui/material/Box';
import TabPanel from '@mui/lab/TabPanel';
import CreateClient from './Dashboard/CreateClient';
import Location from './Locations/Location';
import ManageLocation from './Locations/ManageLocation';
import Facilities from './Facilities/Facilities';
import Report from './Report/Report';
import ManageFacilities from './Facilities/ManageFacilities';
import CreateReport from './Report/CreateReport';
import Opportunity from './Opportunity/Opportunity';
import ManageOpportunity from './Opportunity/ManageOpportunity';
import ProjectManagement from './ProjectManagement/ProjectManagement';
import ManageProjectManagement from './ProjectManagement/ManageProjectManagement';
import { Can, AbilityContext } from '../Context/Can';
import { useAbility } from '@casl/react';
import { PermissionRoute } from './Common/PermissionRoute';
import { tabStyle, tabListStyle } from '../theme/formStyles';
import { useSelector } from 'react-redux';


export default function ClientSettings() {
  const { client_id, tabId, action } = useParams();
  console.log('action: ', action);
  const navigate = useNavigate();
  const [value, setValue] = useState(tabId || 'general');
  const location = useLocation();
  const state = useSelector(st => st);
  const { currentUser } = state;

  // Hardcoded facility edit permission for specific users on Embark client
  const allowedEmailsForEmbark = ['accounts@astertechnologies.in', 'aman.mathur@astertechnologies.in'];
  const hasSpecialFacilityAccess = client_id === 'embarkwater-com' && allowedEmailsForEmbark.includes(currentUser?.uniqueId);
  const ability = useAbility(AbilityContext);
  const canViewOpportunity = ability.can('view', 'Opportunity');
  const canViewProjectManagement = ability.can('view', 'ProjectManagement');
  const isAmazonInstance = window.location.hostname.split('.')[0] === 'amazon';

  useEffect(() => {
    setValue(tabId)
  }, [tabId]);

  useEffect(() => {
    if (tabId === 'opportunity' && !canViewOpportunity) {
      navigate('/dashboard');
    }
    if (tabId === 'project_management' && !canViewProjectManagement) {
      navigate('/dashboard');
    }
  }, [tabId, canViewOpportunity, canViewProjectManagement]);

  const handleTabSwitch = (event, newValue) => {
    setValue(newValue);
    navigate(`/client/${client_id}/settings/${newValue}`)
  };

  let locationComponent = <Can I="view" a="Location"><ManageLocation /></Can>
  if(action === 'create'){
    locationComponent = <PermissionRoute I="view" a="CreateLocation"><Location /></PermissionRoute>
  }else if(action === 'edit'){
    locationComponent = <PermissionRoute I="view" a="EditLocation"><Location /></PermissionRoute>
  }else if(action === 'view'){
    locationComponent = <PermissionRoute I="view" a="EditLocation"><Location /></PermissionRoute>
  }

  let facilityComponent = hasSpecialFacilityAccess ? <Facilities /> : <Can I="view" a="Facility"><Facilities /></Can>
  if(action === 'create'){
    facilityComponent = <PermissionRoute I="view" a="CreateFacility"><ManageFacilities /></PermissionRoute>
  }else if(action === 'edit'){
    facilityComponent = hasSpecialFacilityAccess ? <ManageFacilities /> : <PermissionRoute I="view" a="EditFacility"><ManageFacilities /></PermissionRoute>
  }else if(action === 'view'){
    facilityComponent = hasSpecialFacilityAccess ? <ManageFacilities /> : <PermissionRoute I="view" a="EditFacility"><ManageFacilities /></PermissionRoute>
  }

  let reportComponent = <Can I="view" a="Report"><Report /></Can>
  if(action === 'create'){
    reportComponent = <PermissionRoute I="view" a="CreateReport"><CreateReport /></PermissionRoute>
  }else if(action === 'edit'){
    reportComponent = <PermissionRoute I="view" a="EditReport"><CreateReport /></PermissionRoute>
  }

  let opportunityComponent = <Can I="view" a="Opportunity"><Opportunity /></Can>
  if(action === 'create'){
    opportunityComponent = <PermissionRoute I="view" a="CreateOpportunity"><ManageOpportunity /></PermissionRoute>
  }else if(action === 'edit'){
    opportunityComponent = <PermissionRoute I="view" a="EditOpportunity"><ManageOpportunity /></PermissionRoute>
  }else if(action === 'view'){
    opportunityComponent = <PermissionRoute I="view" a="EditOpportunity"><ManageOpportunity /></PermissionRoute>
  }

  let projectManagementComponent = <Can I="view" a="ProjectManagement"><ProjectManagement /></Can>
  if(action === 'create'){
    projectManagementComponent = <PermissionRoute I="view" a="CreateProjectManagement"><ManageProjectManagement /></PermissionRoute>
  }else if(action === 'edit'){
    projectManagementComponent = <PermissionRoute I="view" a="EditProjectManagement"><ManageProjectManagement /></PermissionRoute>
  }else if(action === 'view'){
    projectManagementComponent = <PermissionRoute I="view" a="EditProjectManagement"><ManageProjectManagement /></PermissionRoute>
  }

  return (
    <div className='w3-padding-large'>
        <div >
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabSwitch} aria-label="lab API tabs example" sx={tabListStyle}>
                    {!hasSpecialFacilityAccess && <Tab label="General Settings" value="general" sx={tabStyle} />}
                    {!hasSpecialFacilityAccess && <Tab label="Reports" value="report" sx={tabStyle} />}
                    {!hasSpecialFacilityAccess && <Tab label="Locations" value="locations" sx={tabStyle} />}
                    <Tab label="Facilities" value="facilities" sx={tabStyle} />
                    {!isAmazonInstance && !hasSpecialFacilityAccess && canViewOpportunity && <Tab label="Opportunity" value="opportunity" sx={tabStyle} />}
                    {!isAmazonInstance && !hasSpecialFacilityAccess && canViewProjectManagement && <Tab label="Project Management" value="project_management" sx={tabStyle} />}
                </TabList>
                </Box>
                {!hasSpecialFacilityAccess && <TabPanel style={{padding:'0px'}} value="general"><CreateClient /></TabPanel>}
                {!hasSpecialFacilityAccess && <TabPanel style={{padding:'0px'}} value="report">{reportComponent}</TabPanel>}
                {!hasSpecialFacilityAccess && <TabPanel style={{padding:'0px'}} value="locations">{locationComponent}</TabPanel>}
                <TabPanel style={{padding:'0px'}} value="facilities">{facilityComponent}</TabPanel>
                {!isAmazonInstance && !hasSpecialFacilityAccess && canViewOpportunity && <TabPanel style={{padding:'0px'}} value="opportunity">{opportunityComponent}</TabPanel>}
                {!isAmazonInstance && !hasSpecialFacilityAccess && canViewProjectManagement && <TabPanel style={{padding:'0px'}} value="project_management">{projectManagementComponent}</TabPanel>}
                </TabContext>
            </Box>
        </div>
    </div>
  );
}
